import Checkbox from '@grnhse/seedling/lib/birch/components/checkbox';
import React from 'react';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { withLocalePrefix } from 'shared/utils/translation';
import { PageName } from '../../shared/types';

type Props = {
  pageName: PageName;
};

const ExcludeHiredCheckbox = ({ pageName }: Props) => {
  const { watch, setValue } = useFormContext();
  const excludeHired: boolean = watch('exclude_hired');

  const t = withLocalePrefix(`talent_${pageName}.labels`);

  return (
    <Checkbox
      data-provides={`talent-${pageName}-exclude-hired-checkbox`}
      checked={excludeHired}
      onChange={(checked) =>
        setValue('exclude_hired', checked, { shouldDirty: true })
      }
      label={t('exclude_hired')}
      value={'exclude_hired'}
    />
  );
};

export default ExcludeHiredCheckbox;
